import { render } from "./dialog-handover.vue?vue&type=template&id=8a1f102a&scoped=true"
import script from "./dialog-handover.vue?vue&type=script&lang=js"
export * from "./dialog-handover.vue?vue&type=script&lang=js"

import "./dialog-handover.vue?vue&type=style&index=0&id=8a1f102a&lang=scss&scoped=true"

import exportComponent from "/var/www/toll-collector/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-8a1f102a"]])

export default __exports__